import React from "react";
import moment from "moment";
import { applyCurrencyMask } from "../../../../../utils/CurrencyMask";
import MoreIcon from "../../../../../components/Icon/MoreIcon";
import PopperCustomMenu from "../../../../../components/Popper/PopperCustomMenu";
import { menuOpcoesPopper } from "./menuOpcoesPopper";
import Situacao from "../../../../../components/Agenda/Situacao/Situacao";

export const getColumns = ({ handleClickVisualizar, functionsPopper, popperRef ,whitelabel,isGerenciador}) => {
  return [
    {
      Header: "Data",
      field: "dataHoraLancamento",
      getValue: (data) => moment(data.dataHoraLancamento).format("DD/MM/YYYY"),
      props: { center: "true" },
    },
    {
      Header: "Orçamento",
      getValue: (data) => data.nome || data.numero || "",
      props: { center: "true" },
    },
    {
      Header: "Orçamentista",
      getValue: (data) => data.orcamentista?.nome || "",
      props: { center: "true" },
    },
    (isGerenciador && ({
        Header: "valor",
        getValue: (data) => applyCurrencyMask(data?.valorTotalLiquido),
        props: { center: "true" },
    })),
    {
      Header: "Status",
      getValue: (data) => {
        const { faturado, status, tipo, statusOrcamentoOdontologico } = data;
        const statusOrcamento = tipo === "ODONTOLOGICO" ? (statusOrcamentoOdontologico?.tipo || statusOrcamentoOdontologico?.nome || "PENDENTE") : status;

        return <Situacao faturado={faturado} label={statusOrcamento} whitelabel={whitelabel}/>
      },
      props: { center: "true" },
    },
    {
      Header: "",
      isClick: true,
      getValue: (data) => {
        const mostrarOpcoes = isGerenciador && data.tipo === "ODONTOLOGICO"
        return (
          <PopperCustomMenu
            ref={popperRef}
            placement={"bottom-end"}
            menuOpcoes={menuOpcoesPopper({
              data,
              whitelabel,
              mostrarOpcoes,
              functions: {
                ...functionsPopper,
                handleFaturar: (e) => functionsPopper.handleFaturar(popperRef?.current?.closePopper(e), data.id),
                handleExcluir: (e) => functionsPopper.handleExcluir(popperRef?.current?.closePopper(e), data),
                handleClickVisualizar: (e) => handleClickVisualizar(popperRef?.current?.closePopper(e), data),
                handleInativar: (e) => functionsPopper.handleInativar(popperRef?.current?.closePopper(e), data),
                handleAtivar: (e) => functionsPopper.handleAtivar(popperRef?.current?.closePopper(e), data),
                handleOpenAgendamento: (e) => functionsPopper.handleOpenAgendamento(popperRef?.current?.closePopper(e), data),
                handleOpenAgendamentoSala: (e) => functionsPopper.handleOpenAgendamento(popperRef?.current?.closePopper(e), data, true),
                closePopper: popperRef?.current?.closePopper,
              },
            })}
            iconButton={<MoreIcon color='#505050' />}
            colorButton={{
              background: '#fff',
            }}
          />
        );
      },
      props: { center: "true" },
    },
  ];
};
